export default (function (value) {
  return Array.isArray(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isArray.js
// module id = vaFe
// module chunks = 0